import React from 'react'
import classes from "./First.module.scss"
import img1 from "../../../assets/img/MainPage/1/1.jpg"
import img2 from "../../../assets/img/MainPage/1/2.png"
import img3 from "../../../assets/img/MainPage/1/star1.png"
import img4 from "../../../assets/img/MainPage/1/star2.png"

const First = () => {
    return (
        <div className={[classes.first, ""].join(" ")}>
            <div className={[classes.firstBody, ""].join(" ")}>
                <div className={[classes.firstContent, ""].join(" ")}>
                    <div className={[classes.firstContentImg, ""].join(" ")}>
                        <img src={img1} alt="" />
                        <div className={[classes.firstContentImgTitle, ""].join(" ")}>
                            Woof! <br />Doggie Wash
                        </div>

                    </div>
                    <div className={[classes.firstContentStar1, ""].join(" ")}>
                        <img src={img3} alt="" />
                    </div>
                    <div className={[classes.firstContentStar2, ""].join(" ")}>
                        <img src={img4} alt="" />
                    </div>
                    <div className={[classes.firstContentDecor1, ""].join(" ")}>
                        Scroll to discover
                    </div>
                    <div className={[classes.firstContentDecor2, ""].join(" ")}>
                        Scroll to discover
                    </div>
                    <div className={[classes.firstContentCloneTitle, ""].join(" ")}>
                        Woof! <br /> Doggie Wash
                    </div>

                </div>
                <p className={[classes.firstText, ""].join(" ")}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque augue eros, pellentesque nec tempor eu, sollicitudin at dolor. Cras commodo venenatis diam, nec venenatis massa auctor at.
                </p>

            </div>

        </div>

    )
}

export default First